import React from "react";
import { Typewriter } from "react-simple-typewriter";

const LanguageTypewriter = () => {
  return (
    <div className="text-center tracking-widest text-xl md:text-2xl font-light text-white pl-12">
      <p>
        Now available in{" "}
        <span
          className="text-transparent inline-block w-[10ch] text-left tracking-wide bg-clip-text bg-gradient-to-r from-[#bdcf32] to-[#5c8500] font-bold"
          style={{ textShadow: "0 0 5px rgba(189, 207, 50, 0.58)" }}
        >
          <Typewriter
            words={[
              "Deutsch",
              "English",
              "Español",
              "Français",
              "हिन्दी",
              "Italiano",
              "日本語",
              "한국어",
              "Polski",
              "Português",
              "Русский",
              "Svenska",
              "ไทย",
              "Türkçe",
              "Українська",
              "Tiếng Việt",
              "简体中文",
              "繁體中文",
            ]}
            loop={0}
            cursor={false}
            typeSpeed={80}
            deleteSpeed={50}
            delaySpeed={1000}
          />
        </span>{" "}
        {/* and 20+ other languages! */}
      </p>
    </div>
  );
};

export default LanguageTypewriter;
